import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_n2mfxxer77: FaireBrandEntity = {
  token: "b_n2mfxxer77",
  type: "brand",
  name: "WIRI",
  avatarUrl:
    "https://cdn.faire.com/fastly/34084af8b5eb64b6a86db3e7a995bbf12c62db56741d945c720296ad6e763075.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8ec6c73a2b66c6ec3a8a97deebfe5ecd320e2562a5955f9fd4be48e95e00544f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/34084af8b5eb64b6a86db3e7a995bbf12c62db56741d945c720296ad6e763075.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8ec6c73a2b66c6ec3a8a97deebfe5ecd320e2562a5955f9fd4be48e95e00544f.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 140,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    'WIRI is a luxury hot sauce made from the Wiri Wiri pepper — a rare, round chili native to Guyana, prized for its fruity heat and near-impossible to find outside of the diaspora. We launched in New York City in May 2026.\n\nFive ingredients. A 6 oz embossed glass bottle. A branded box. WIRI was built to sit on a kitchen counter, not get lost at the back of a cabinet.\n\nThe hot sauce category has been dominated by either mass-market bottles or hyper-casual "craft" brands. WIRI exists in neither space. We\'re a luxury pantry object — made for the dinner table, the gift bag, the host who has everything.\n\nShop via our direct link: https://wiri.faire.com',
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:18:08.370Z",
    importedBy: "entity-db-cli",
  },
};
